// gatsby-browser.js
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation !== null) {
    window.location.reload();
  }
};
